const colors = ['#F8C488', '#D3B9CC', '#A2DAD0', '#e8a0a5', '#89a0e0', '#82e0a7', '#d991c2'];

export default colors;